export default __webpack_public_path__ + "static/media/timerIcon.83153b6d.svg";